"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.anchorLink).on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    handlers.scrollToAnchorLink($(this));
  });
};
